export const areasColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  { id: 'nombre', label: 'Nombre', type: 'text', required: true },
  { id: 'descripcion', label: 'Descripción', type: 'text', required: false },
];

export const columnsExcel = [
  { key: 'estado', header: 'Estado' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'descripcion', header: 'Descripción' },
];
